export default __webpack_public_path__ + "static/media/hoitokeskustelu-grey.b14183bd.svg";